import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

const focusActiveCss = {
  fontWeight: fontWeights.medium,
  '&:after': {
    content: '""',
  },
};

export const containerPaddingCss = {
  paddingTop: 96,
  [MediaQueries.lgAndUp]: {
    paddingTop: 150,
  },
};

// Margin bottom 0, 125px is taking into account the padding
// from the following component, which when added up, the
// spacing between component are 0 and 160px.
export const containerMarginCss = {
  margin: '96px 0 0',
  [MediaQueries.lgAndUp]: {
    margin: '160px 0 125px',
  },
};

export const headlineCss = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  position: 'relative',
  marginBottom: 32,
  [MediaQueries.lgAndUp]: {
    marginBottom: 40,
  },
});

export const itemTabCss = css({
  textAlign: 'center',
  flex: '0 0 auto',
  [MediaQueries.md]: {
    minWidth: '28%',
  },
  [MediaQueries.lgAndUp]: {
    flex: 1,
    minWidth: 'auto',
  },
});

export const solutionTabContentCss = css({
  [MediaQueries.mdAndUp]: {
    minHeight: 400,
  },
  [MediaQueries.lgAndUp]: {
    minHeight: 350,
  },
});

export const textHeaderCss = css(typography.effra16, {
  display: 'inline-block',
  height: '100%',
  padding: '34px 4px 26px',
  pointerEvents: 'none',
  position: 'relative',
  '&:after': {
    border: `1px solid ${colorsPalette.red} `,
    bottom: 0,
    height: 1,
    left: 0,
    position: 'absolute',
    width: '100%',
  },
  [MediaQueries.mdAndUp]: {
    padding: '40px 2px',
  },
  '&[data-active="true"]': focusActiveCss,
});

export const TabCtaCss = css({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  outline: 'none',
  padding: '0 20px',
  width: '100%',
  '&:focus': {
    span: focusActiveCss,
  },
});

export const animationContainerCss = css({
  display: 'none',
  pointerEvents: 'none',
  position: 'absolute',
  width: '100%',
  zIndex: 1,
  [MediaQueries.mdAndUp]: {
    display: 'block',
    paddingTop: 220,
  },
  [MediaQueries.lgAndUp]: {
    paddingTop: 190,
  },
});

export const animationContentCss = css({
  maxHeight: 400,
});

export const separatorLineCss = css({
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  paddingBottom: 96,
  [MediaQueries.lgAndUp]: {
    paddingBottom: 160,
  },
});
